import { useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TextField,
} from '@mui/material';

import { Helmet } from 'react-helmet-async';

import FormStyle from '../FormStyle';
import showTableData from '../Functions/showTableData';
import api from '../../../../services/api';
import SentEmailWithSuccess from './SentEmailWithSuccess';

function ChangeForm(
  {
    setIsChangingEmail,
    addFormValues,
    getValues,
    errors,
  }: {
    setIsChangingEmail: (isChangingEmail: boolean) => void,
    addFormValues: any,
    getValues: any,
    errors: any,
  },
) {
  // variables
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [hasSentMail, setHasSentMail] = useState(false);

  // functions
  const handleUpdateEmail = () => {
    setIsLoading(true);
    api.post('/v1/users/send-email-change', { email: getValues('email') })
      .then(() => {
        setHasSentMail(true);
      }).catch((error) => {
        setErrorMessage(error.response.data.errors.email[0]);
      }).finally(() => {
        setIsLoading(false);
      });
  };

  // render conditions
  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="90vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (hasSentMail) {
    return (
      <SentEmailWithSuccess
        setIsChangingEmail={setIsChangingEmail}
        setHasSentMail={setHasSentMail}
      />
    );
  }

  return (
    <div className="main">
      <Helmet>
        <title>メールアドレス変更</title>
      </Helmet>
      <main
        style={{
          overflowY: 'auto',
          height: 'calc(100vh - 65px)',
        }}
      >
        <Box className="container-fluid">
          <Box
            sx={FormStyle.previewHeader}
          >
            <h1 className="text-bold">メールアドレス変更</h1>
            <p className="text-center">
              変更したいメールアドレスをご入力いただき、「メールを送信する」ボタンを押してください。
              <br />
              ご入力いただいたメールアドレスに、本人確認用メールをお送りします。
            </p>
          </Box>
          <Box className="card">
            <Box className="card-body">
              <Grid
                container
                justifyContent="center"
                spacing={1}
              >
                <Grid
                  item
                  xs={12}
                >
                  <Table className="table-form-setting">
                    <TableBody>
                      {
                        showTableData({
                          ticket: 'メールアドレス',
                          value: (
                            <TextField
                              {...addFormValues('email')}
                              size="small"
                              error={!!errorMessage}
                              helperText={errorMessage}
                              sx={{ width: '100%' }}
                              placeholder="mail@build-self.com"
                            />
                          ),
                          isRequired: true,
                        })
                      }
                    </TableBody>
                  </Table>
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    className="btn-outline-secondary"
                    onClick={() => { setIsChangingEmail(false); }}
                  >
                    戻る
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    onClick={handleUpdateEmail}
                    variant="contained"
                  >
                    メールを送信する
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </main>
    </div>
  );
}

export default ChangeForm;
